/*require('./../style/loading.less');*/
import Vm from './sw-component/utils/Vm'; 
var $ = require('jQuery');
var Component = require('./Component');
var template = require('../template/loading.html');
var sw = require('./sw-component/sw/loading.sw');


class Loading extends Vm {
    constructor (options) {
      var defaults = {
        template: template
      };
      $.extend(defaults, options);
      super(defaults);
    }

    vm_template () {
        return sw();
    } 

    open() {
        let self = this;
        self.show.call(this);
    }

    close() {
        let self = this;
        self.hide.call(this);
    }
}

module.exports = Loading;
